// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="runner_battler.RbSessionsCountChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="runner_battler.RbSessionsLengthChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="runner_battler.RbSessionsLengthPerDayChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="runner_battler.RbSessionsLengthSumInFirstDayChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;